import {emotionStyled} from '@packages/utilities/styled';
import {tokens} from '../../themes';
import {Button} from '../Button';

export const IconButtonView = emotionStyled(Button)(
  {
    padding: tokens.ui.iconButton.padding.comfortable,
  },
  {
    componentName: 'IconButton',
    variants: {
      density: {
        compact: {
          padding: tokens.ui.iconButton.padding.compact,
          borderRadius: '$1',
        },
        comfortable: {},
      },
      size: {
        medium: {},
        'x-large': {},
      },
      isBranded: {
        true: {
          padding: '$3',
        },
      },
    },
    compoundVariants: [
      {
        conditions: {
          density: 'compact',
          size: 'x-large',
        },
        css: {
          borderRadius: '$1',
        },
      },
      {
        conditions: {
          isBranded: true,
          density: 'compact',
        },
        css: {
          padding: '$2',
        },
      },
    ],
    defaultVariants: {
      density: 'comfortable',
      isBranded: false,
    },
  }
);
